const Form048EN = {
    stepName: {
        importantNotes: "Important Notes",
        receipt: "Payment Receipt",
        confirmation: "Confirmation",
        schoolInformation: "School Information",
    },
    label: {
        noteTitle: "Personal Information Collection Statement",
        // p1:"The Other Charges are applicable to only former child care centres that received such subsidy from the Social Welfare Department immediately before September 2005."
        noteDetails:
            "The Other Charges are applicable to only former child care centers that received such subsidy from the Social Welfare Department immediately before September 2005.",
        title: "Personal Information Collection Statement",
        statement:
            "I have read, understood and agreed to the above terms and conditions.",
        iamSmartStatement:
            "I understand applicant and the approving authority of the school need to have an “iAM Smart+” account to process the application.",
        receiptType: "Receipt Type",
        refundTips:
            "Please refund the other charges paid by my school as follows",
        chargesGp: {
            month: "Month",
            startDate: "Start date",
            startDateLowerCase: "start date",
            endDate: "End date",
            start_end_date: "Start/End Date",
            managedCost: "Management Fee(HKD $)",
            ACFee: "Air-conditioning Fee(HKD $)",
            attachment: {
                tips: "Copy of the receipt (or certified true copy of the receipt) is attached for reference.",
                managementFee: "Attachment(Management Fee)",
                acFee: "Attachment(Air-conditioning Fee)",
                others: "Attachment(Others)",
            },
        },
        header: {
            headerOne: "Important Notes",
        },
        dateTypeCode: {
            month: "Month",
            start_end_date: "Start/End Date",
        },
        specialCharacter: {
            slash: "/",
        },
        contact: {
            supervisorName: "Name of Supervisor",
            schoolName: "School Name",
            personName: "Contact Person",
            telephone: "Telephone No.",
        },
        applicantInformation: "Applicant Information",
    },
    impNotes: {
        note1: "The Other Charges are applicable to only former child care centers that received such subsidy from the Social Welfare Department immediately before September 2005.",
        note2: "Applicant without an “iAM Smart+” account is required to return the completed form to Joint Office for Kindergartens and Child Care Centres for processing (Address: Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong).　Please ensure that sufficient postage is paid to avoid unsuccessful delivery. Any underpaid mail items will be disposed of by the Hongkong Post.",
    },
    noteList: {
        title1: "Purpose of Collection",
        title2: "Classes of Transferees",
        title3: "Access to Personal Data",
        note1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        note1a: "Activities relating to the processing, authentication and counter-checking of the Refund of Other Charges;",
        note1b: "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
        note1c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
        note1d: "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
        note1e: "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
        note1f: "Activities relating to compilation of statistics, research and Government publications; and",
        note1g: "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules); and the Codes of Aid, the Child Care Services Ordinance (Cap.243) and its subsidiary legislation (i.e., the Child Care Services Regulations (Cap 243 A) )",
        note2: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",
        note3: "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        note3a: "other Government bureau and departments for the purposes mentioned in paragraph 1 above;",
        note3b: "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
        note3c: "where you have given your prescribed consent to such disclosure; and",
        note3d: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        note4: "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to intake officer at Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong or email to ",
        email: "jokc@edb.gov.hk",
        noteEnd: ".",
    },
    receiptType: {
        // receipt: "Payment's receipt",
        photocopy: "upload photocopies",
        remark: {
            title: "Remark",
            content: "The maximum size of each file is 10MB",
            content2: "Acceptable file types: jpeg, jpg, png, pdf, zip",
            content3: "Maximum number of files: 20",
        },
    },
    errorMsg: {
        amount: {
            min: "Please input a valid price",
            max: "Price must be at most 6 digits",
            maxDecimal: "Price must be at most 2 decimal places",
        },
        atLeastOne:
            "Please fill in at least one of Management Fee or Air-conditioning Fee",
        na: "N/A",
    },
};
export default Form048EN;
